import {jsx as _jsx} from "react/jsx-runtime";
import {cn} from '../cn'

const Email = ({className, ...props}) => (
  _jsx('svg', {
    viewBox: "0 0 24 24"   ,
    'aria-hidden': "true",
    focusable: "false",
    ...props,
    className: cn(
      'inline-block h-[1em] w-[1em] shrink-0 select-none fill-current text-[24px]',
      className
    ),
 children: 
    _jsx('path', { d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 4-8 5-8-5V6l8 5 8-5z"               ,} )
  })
)

export default Email
